import { ethers } from 'ethers'
import { CHAIN_ID } from '../../constants'
import networks from '../../networks.json'
import MetarunTokenAbi from '../../abis/MetarunTokenAbi.json'
import MetarunStakingAbi from '../../abis/MetarunStakingAbi.json'

export function getMetarunToken() {
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  const MetarunToken = new ethers.Contract(
    networks[CHAIN_ID].metarunTokenContract.address,
    MetarunTokenAbi,
    signer
  )
  return MetarunToken
}

export function getFixedStaking(contractAddress) {
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  const FixedStaking = new ethers.Contract(
    contractAddress,
    MetarunStakingAbi,
    signer
  )
  return FixedStaking
}
